// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fullwidth[data-v-33e4040f]{width:100%}.discount[data-v-33e4040f]{padding-bottom:5px}.discount span[data-v-33e4040f]{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.partner-slug[data-v-33e4040f]{text-transform:capitalize}.free-partner-logo[data-v-33e4040f]{display:block;margin:0 auto;max-width:350px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
